"use client";

import React from "react";
import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const towns = ["Rumson", "Red Bank", "Little Silver", "Middletown", "Atlantic Highlands", "Sea Bright", "Monmouth Beach"];
const socials = [{
  name: "Instagram",
  icon: Instagram,
  href: "https://instagram.com/physicallysound"
}];
export default function ServiceAreaConnection() {
  return <section data-section-id="172783" id="footer" className="dark bg-background text-foreground py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <img src="https://ruling-egret.10web.cloud/wp-content/uploads/2026/04/Physically-Sound-PT-Logo-icon-3.png" alt="Physically Sound" className="h-7 w-auto object-contain self-start" />
            <p className="text-sm leading-relaxed text-muted-foreground font-sans">
              Premium mobile concierge physical therapy for athletes and active adults in Monmouth County. Expert 1-on-1 care delivered directly to your door.
            </p>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="mb-6 text-lg font-bold tracking-tight text-foreground uppercase">
              Service Areas
            </h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
              {towns.map((town, i) => <div key={town} data-index={i}>
                  <Link to="#" className="text-sm text-muted-foreground transition-colors hover:text-accent font-sans">
                    {town}
                  </Link>
                </div>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 lg:items-end">
            <h3 className="text-lg font-bold tracking-tight lg:text-right text-foreground uppercase">
              Connect With Us
            </h3>
            <div className="flex gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <div key={social.name} data-index={i}>
                    <Link to={social.href} className="text-muted-foreground transition-colors hover:text-accent">
                      <Icon className="size-5" />
                      <span className="sr-only">{social.name}</span>
                    </Link>
                  </div>;
            })}
            </div>
            <Button asChild className="mt-2 w-full sm:w-auto bg-accent text-accent-foreground hover:bg-accent/90 transition-all font-bold tracking-tight rounded-sm">
              <Link to="#">Book Now</Link>
            </Button>
          </div>
        </div>

        <Separator className="my-8 bg-border/20" />

        {}
        <div className="flex flex-col items-center justify-between gap-4 text-center text-xs text-muted-foreground md:flex-row md:text-left font-sans">
          <p>
            © {new Date().getFullYear()} Physically Sound. All rights reserved.
          </p>
          <p className="max-w-2xl">Disclaimer: The information provided on this website is for educational purposes only and does not substitute for professional medical advice or treatment.</p>
        </div>
      </div>
    </section>;
}